import {Component, OnDestroy, OnInit} from '@angular/core';
import {ChannelService} from '../../channel.service';
import {RulesService} from '../../rules.service';
import {Router} from '@angular/router';
import {SpinnerService} from '../../../core/spinner/spinner.service';
import {PageCanDeactivate} from '../../common/can-deactivate/can-deactivate-page';
import {Constants} from '../../constants';

@Component({
  selector: 'app-select-channels',
  templateUrl: './select-channels.component.html',
  styleUrls: ['./select-channels.component.scss']
})
export class SelectChannelsComponent  extends PageCanDeactivate implements OnInit, OnDestroy {
  private actionList = [];
  private loading: boolean;
  private channelSub;
  selectedActions = [];

  constructor(private channelService: ChannelService,
  private ruleService: RulesService,
  private router: Router,
  private spinner: SpinnerService) { super(); }

  get isLoading() {
    return this.loading;
  }
  get actions() {
    return this.actionList;
  }

  get ruleId(): number|string {
    return this.ruleService.getRuleModel() && this.ruleService.getRuleModel().id ?
      this.ruleService.getRuleModel().id : 'new';
  }
  get hasChanges(): boolean{
    return (!!this.selectedActions.length || !!this.configuredActions.length) ||
      (this.ruleService.rows && !!this.ruleService.rows.length);
  }
  get channelEditUri() {
    return `/rules/${this.ruleId}/step-4`;
  }
  get configuredActions () {
    return this.ruleService.getConfiguredActions();
  }
  get newActions() {
    const selectedAction = this.ruleService.getConfiguredActions().map(item => item.name);
    return this.actionList.filter(item => selectedAction.indexOf(item.name) === -1);
  }
  ngOnInit() {
    if (!this.ruleService.rows || !this.ruleService.rows.length) {
      this.spinner.hide();
      this.goToFirstStep();
      return;
    }
    this.getActions();
  }
  selectChannel(isChecked, channel) {
    if (isChecked) {
      this.selectedActions.push(channel);
      return;
    }
    this.selectedActions = this.selectedActions.filter((item) => item.id !== channel.id);
  }

  back() {
    let path = this.ruleId === 'new' ? '/rules/things/new/step-2' : `/rules/${this.ruleId}/edit/step-2`;
    this.router.navigate([path]);
  }
  getActions() {
    this.spinner.show();
    this.channelSub = this.channelService
      .getActions()
      .subscribe((items) => { this.spinner.hide(); this.actionList = items; },
        error => this.spinner.hide());
  }
  getActionImageUri(action) {
    return `./assets/images/${action.name}_icon.svg`;
  }
  ngOnDestroy() {
    if (this.channelSub) {
      this.channelSub.unsubscribe();
    }

  }
  next() {
    if (!this.selectedActions.length && !this.configuredActions.length) {
      return;
    }
    if (this.configuredActions.length && !this.selectedActions.length) {
      this.router.navigate([`rules/${this.ruleId}/step-5`]);
      return;
    }
    this.router.navigate([`rules/${this.ruleId}/step-4`]);
  }

  goToFirstStep() {
    this.router.navigate(['rules/new/step-1']);
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/new-rule/select-channels/select-channels.component.ts